// src/App.js
import React from "react";
import ChartContainer from "./ChartContainer";
import "./index.css";

export default function App() {
  return (
    <div className="app-root">
      <ChartContainer />
    </div>
  );
}
